// extracted by mini-css-extract-plugin
export var grid = "_7-5";
export var layout = "_7-0";
export var leftColumn = "_7-1";
export var leftInner = "_7-2";
export var rightColumn = "_7-3";
export var rightInner = "_7-4";